import React from 'react';
import { Box, type SelectChangeEvent } from '@mui/material';
import type { RaterOptionKeysType } from '../types';
import { InputLabelBase } from '../../../../../components/inputs/InputLabelBase';
import SelectBase from '../../../primeX-underwriter/components/footer/SelectBase';
import { deriveRaterOptionsFormatter } from '../utils';
import type { PrimeXUnderwriteQuoteHandlers } from '../views/underwriter/types';
import { Show } from '../../../../../components/Show';
import {
  UW_BORDERLESS_SELECT_SX,
  UW_GLOBAL_LABEL_STYLE,
} from '../views/underwriter/components/uwTileSpacing';

const RaterOptionsInput = ({ name, label, ...props }: RaterOptionsInput) => {
  const handleRaterOptionChange = (e: SelectChangeEvent<any>) => {
    props.setRaterOption?.({
      id: name,
      value: e.target.value,
    });
  };

  const _options = props.options.map(deriveRaterOptionsFormatter(name));

  return (
    <Box>
      <Show when={Boolean(label)}>
        <InputLabelBase
          style={{
            padding: 0,
            paddingBottom: '0.25rem',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            // The same label line as Carrier beside it, so the controls align.
            ...UW_GLOBAL_LABEL_STYLE,
          }}
        >
          {label}
        </InputLabelBase>
      </Show>
      <SelectBase
        options={_options}
        name={name}
        value={props.value}
        onChange={handleRaterOptionChange}
        disabled={props.disabled}
        // Only the underwriter globals row renders this; it matches the
        // selects beside it.
        sx={UW_BORDERLESS_SELECT_SX}
      />
    </Box>
  );
};

export default RaterOptionsInput;

type RaterOptionsInput = {
  name: RaterOptionKeysType;
  label?: string;
  options: any[];
  value: string | number;
  disabled?: boolean;
  setRaterOption?: PrimeXUnderwriteQuoteHandlers['setRaterOption'];
};
